/**
 * Observability bootstrap: device + session context for Faro and apiClient.
 * Call getObservabilityContext() at app startup (sync); no side effects that block render.
 */

import { getDeviceId, getDeviceMeta } from './device.service';
import { getSessionId } from './session.service';
import type { ObservabilityContext } from './types';

let context: ObservabilityContext | null = null;

/**
 * Returns device id, device meta, and session id. Cached after first call.
 * Safe to call from index.js before React render.
 */
export function getObservabilityContext(): ObservabilityContext {
  if (context) return context;
  const deviceId = getDeviceId();
  const deviceMeta = getDeviceMeta();
  const sessionId = getSessionId();
  context = { deviceId, deviceMeta, sessionId };
  return context;
}
